"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsForbiddenTerm = exports.formHasGuestColumnOnGuestList = exports.formHasCheckInOnGuestList = exports.formHasCheckInActions = exports.formHasFulfillmentTab = exports.isEventDiscoverabilityEligible = exports.formHasReminderEventDetails = exports.formHasGuestTab = exports.formHasCheckinManager = exports.formCategoriesWithCheckinManager = exports.isTicketingCategory = void 0;
const enums_1 = require("../enums");
const fulfillment_1 = require("./fulfillment");
const FORBIDDEN_TERMS_ON_FORM_TITLE_AND_DESCRIPTION = ["lawrence lim teng chye"];
const isTicketingCategory = (category) => {
    return Object.values(enums_1.TicketingFormCategory).includes(category);
};
exports.isTicketingCategory = isTicketingCategory;
exports.formCategoriesWithCheckinManager = [
    enums_1.FormCategory.Event,
    enums_1.FormCategory.Custom,
    enums_1.FormCategory.MembershipV2,
];
const formCategoriesWithGuestTab = [
    ...exports.formCategoriesWithCheckinManager.filter((c) => c !== enums_1.FormCategory.MembershipV2),
    enums_1.FormCategory.Shop,
    enums_1.FormCategory.Lottery,
    enums_1.FormCategory.Sweepstakes,
];
const formHasCheckinManager = (formCategory) => exports.formCategoriesWithCheckinManager.includes(formCategory);
exports.formHasCheckinManager = formHasCheckinManager;
const formHasGuestTab = (formCategory) => formCategoriesWithGuestTab.includes(formCategory);
exports.formHasGuestTab = formHasGuestTab;
const formHasReminderEventDetails = (formCategory) => formCategory === enums_1.TicketingFormCategory.Event;
exports.formHasReminderEventDetails = formHasReminderEventDetails;
const isEventDiscoverabilityEligible = (formCategory) => formCategory === enums_1.TicketingFormCategory.Event;
exports.isEventDiscoverabilityEligible = isEventDiscoverabilityEligible;
const formHasFulfillmentTab = (formCategory) => (0, fulfillment_1.supportsFulfillment)(formCategory);
exports.formHasFulfillmentTab = formHasFulfillmentTab;
const formHasCheckInActions = (formCategory) => {
    return formCategory !== enums_1.FormCategory.MembershipV2 && !(0, enums_1.isDrawingFormCategory)(formCategory);
};
exports.formHasCheckInActions = formHasCheckInActions;
const formHasCheckInOnGuestList = (formCategory) => {
    return formCategory !== enums_1.FormCategory.MembershipV2 && !(0, enums_1.isDrawingFormCategory)(formCategory);
};
exports.formHasCheckInOnGuestList = formHasCheckInOnGuestList;
const formHasGuestColumnOnGuestList = (formCategory) => {
    return formCategory !== enums_1.FormCategory.Shop && !(0, enums_1.isDrawingFormCategory)(formCategory);
};
exports.formHasGuestColumnOnGuestList = formHasGuestColumnOnGuestList;
const normalize = (str) => {
    return str
        .toLowerCase() // lowercase the string
        .replace(/[^a-z0-9]+/gi, " ") // replace non alphanumeric characters with a space
        .replace(/\s+/g, " ") // reduce multiple spaces to a single space
        .trim(); // trim leading and trailing spaces
};
const containsForbiddenTerm = (input) => {
    const normalizedInput = normalize(input);
    return FORBIDDEN_TERMS_ON_FORM_TITLE_AND_DESCRIPTION.some((term) => {
        return normalizedInput.includes(term);
    });
};
exports.containsForbiddenTerm = containsForbiddenTerm;
